import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { FieldValueRenderer } from '@/components/molecules/FieldValueRenderer';
import { useTranslator } from '@/hooks/useTranslator';
import { Field, FieldType } from '@/types/fields';
import { createFieldRenderer } from '@/utility/createFieldRenderer';

interface Props {
  readonly value: unknown;
  readonly field: Field<unknown>;
}

export const VerifyBusinessSummaryEntry: React.FC<Props> = (props: Props): React.ReactNode => {
  const { field, value } = props;

  const tr = useTranslator();
  const label = React.useMemo(
    (): string => tr('label' in field ? field.label : field.title),
    [field, tr],
  );

  // For embedded fields we need to flatten the child fields
  if (field.type === FieldType.embedded) {
    const { fields } = field;
    return fields.map(createFieldRenderer(value));
  } else if (field.type === FieldType.composite && typeof value === 'object') {
    const { fields } = field;
    return fields.map(createFieldRenderer(value));
  }

  return (
    <Box sx={styles.entry}>
      <Typography variant="body2">{label}</Typography>
      <FieldValueRenderer value={value} field={field} />
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  entry: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    minHeight: 52,
  },
};
